import { useIsBigScreen } from '../../../../customHooks/useIsBigScreen';
import { useIsFirebaseDown } from '../../../../lib/store/dashboard.store';
import { handleOpenEmail } from '../../../../utils';

export const AppDownPage = () => {
  const isBigScreen = useIsBigScreen();
  const isFirebaseDown = useIsFirebaseDown((state: any) => state.isAppDown);
  return (
    <>
      <div
        className={`${
          isBigScreen ? 'pt-6' : 'pt-2'
        } flex flex-col items-center justify-center bg-white text-center font-montserrat`}>
        <div className="grid grid-cols-3 gap-4 items-center w-full ">
          <div className={`${isBigScreen ? '' : ''} flex justify-start`}>
            <img
              src="/img-animated/two-clouds.apng"
              className={`${isBigScreen ? '' : 'w-[250px] h-[250px]'}`}
              alt="Cloud Left"
            />
          </div>

          <div
            className={`${
              window.outerWidth <= 820 || window.innerWidth <= 820 ? '' : '-ml-12'
            } text-center ${isBigScreen ? 'mt-0' : ''}`}>
            <div
              className={`${
                isFirebaseDown
                  ? !isBigScreen
                    ? 'text-[36px]'
                    : 'text-[45px]'
                  : window.outerWidth <= 820 || window.innerWidth <= 820
                  ? 'text-[30px] pr-4'
                  : !isBigScreen
                  ? 'text-[36px] pr-[24rem]'
                  : 'text-[45px] pr-[24rem]'
              } font-bold mb-6 text-[#000000] ${isBigScreen ? 'pb-16' : 'pb-8'} `}>
              {isFirebaseDown ? 'Temporary Outage' : 'Oops...'}
            </div>
            <div
              className={`${
                isFirebaseDown
                  ? !isBigScreen
                    ? 'text-xl'
                    : 'text-[24px]'
                  : window.outerWidth <= 820 || window.innerWidth <= 820
                  ? 'text-[20px]'
                  : !isBigScreen
                  ? 'text-[22px]'
                  : 'text-[26px]'
              } text-[#000000] mb-4 font-semibold flex flex-col`}>
              <span>
                {isFirebaseDown
                  ? 'Our system is currently down due to a Google services outage. We’ll be back as soon as they are.'
                  : 'We are sorry our website is down.'}
              </span>

              {!isFirebaseDown && <span className="pt-10"> We are working on it.</span>}
            </div>
          </div>

          <div className={`${isBigScreen ? '' : ''} flex justify-end`}>
            <img
              src="/img-animated/two-clouds.apng"
              className={`${isBigScreen ? '' : 'w-[250px] h-[250px]'}`}
              alt="Cloud Right"
            />
          </div>
        </div>

        <div className={`${isBigScreen ? 'mt-0' : '-mt-2'}`}>
          <img
            src="/img-animated/one-cloud.apng"
            className={`${isBigScreen ? '' : 'w-[250px] h-[250px]'}`}
            alt="Cloud Bottom"
          />
        </div>

        <p
          className={`${
            window.outerWidth <= 820 || window.innerWidth <= 820
              ? 'text-base'
              : !isBigScreen
              ? 'text-lg'
              : 'text-[22px]'
          } text-[#000000] pb-12 ${isFirebaseDown ? 'font-semibold' : ''}`}>
          {isFirebaseDown ? (
            <span className="2xl:pr-14 pr-10">
              Thanks for your patience — please try again later!
            </span>
          ) : (
            <>
              For questions or help:&nbsp;
              <span
                className="cursor-pointer underline font-semibold underline-offset-8 text-[#1C8CA6]"
                onClick={handleOpenEmail}>
                support@drumroll.ai
              </span>
            </>
          )}
        </p>
      </div>
    </>
  );
};
